import { render, staticRenderFns } from "./ToSignPerson.vue?vue&type=template&id=38863fc4&scoped=true&"
import script from "./ToSignPerson.vue?vue&type=script&lang=js&"
export * from "./ToSignPerson.vue?vue&type=script&lang=js&"
import style0 from "./ToSignPerson.vue?vue&type=style&index=0&id=38863fc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38863fc4",
  null
  
)

export default component.exports